/**
 * When Analytics / Worklog completes a Full, Incremental, or Fix-Version DB sync,
 * Forecast data in Postgres is newer but SPA clients may keep a warm in-memory forecast
 * cache (`ForecastPage`). Other tabs likewise need nudged refresh.
 */

export const RELIX_JIRA_WORKLOG_ISSUES_SYNCED_EVENT = 'relix:jira-worklog-issues-synced';

export const RELIX_JIRA_WORKLOG_ISSUES_SYNCED_BC = 'relix-jira-worklog-issues-synced';

export function notifyJiraWorklogIssuesSynced(): void {
  window.dispatchEvent(new Event(RELIX_JIRA_WORKLOG_ISSUES_SYNCED_EVENT));
  try {
    const bc = new BroadcastChannel(RELIX_JIRA_WORKLOG_ISSUES_SYNCED_BC);
    bc.postMessage({});
    bc.close();
  } catch {
    // Private mode / no BroadcastChannel
  }
}
